import { createI18n } from 'vue-i18n'

const loadMessages = async () => {
  const en = {
    i18n: (await import('./en')).default
  }

  const pt = {
    i18n: (await import('./pt')).default
  }

  return { en, pt }
}

const messages = await loadMessages()

const i18n = createI18n({
  locale: 'pt', // default
  fallbackLocale: 'pt',
  messages
})

export default i18n
